import { Component } from '@angular/core';
import { ShowOnScrollDirective } from '@app/directives/show-on-scroll.directive';

@Component({
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.css'],
  imports: [ShowOnScrollDirective]
})
export class ScrollToTopComponent {

  public scrollToTop() {
    const bodyElement = document.querySelector('body');
    bodyElement!.scrollIntoView({ behavior: 'smooth' });
  }
}
